export default {"src":"/evde-internet/_next/static/media/arrow-left.8eeb179d.svg","height":24,"width":24};